import React, { Component, Children } from "react"
import PropTypes from "prop-types"
import update from "immutability-helper"
import {
  reduxForm,
  FieldArray,
  Field,
  formValueSelector,
  change,
} from "redux-form"
import { connect } from "react-redux"
import compose from "recompose/compose"
import styled from "styled-components"
import { Flex } from "rebass"
import {
  Toolbar,
  FormField,
  GET_LIST,
  setSidebarVisibility,
  showNotification as showNotificationAction,
} from "admin-on-rest"
import { filter } from "lodash"
import {
  Table,
  TableBody,
  TableHeader,
  TableFooter,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table"
import { TextField } from "redux-form-material-ui"
// import MenuItem from "material-ui/MenuItem"
import { Card, CardHeader, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
import ContentAdd from "material-ui/svg-icons/content/add-circle"
import ActionDelete from "material-ui/svg-icons/action/highlight-off"
import RaisedButton from "material-ui/RaisedButton"
import Avatar from "material-ui/Avatar"
import IconPeople from "material-ui/svg-icons/social/people"
import getDefaultValues from "../components/form/getDefaultValues"
import { ValuesForm, SearchMarketerContentShip } from "../components"
//import {layouts} from './content/layouts/';
import EditorLayout from "./EditorLayout"
import { RestClient, RestApiShortUrl } from "../restClient"

class TemplateForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit((values) => {
      values.content = this.state.layoutSelected
      // if(values.marketer_id ===  null){
      //   values.marketer_id = 0;
      // }
      const isZeroMarketerId = filter(this.props.record.marketers, function (
        o
      ) {
        return o.marketer_id === 0
      })
      if (isZeroMarketerId.length === 0) {
        if (values.slug === this.state.slug) {
          this.props.save(values, redirect)
        } else {
          this.checkContentSlug(values, redirect)
        }
      } else {
        showNotificationAction(
          "Please Select Marketer or Delete item list marketer",
          "warning"
        )
      }
    })

  constructor(props) {
    super(props)
    const { content, slug } = props.record
    let data = undefined
    if (!Array.isArray(content)) {
      data = content
    }
    this.state = {
      isSelected: false,
      layoutSelected: props.record.content || [],
      oldMarketers: props.record.marketers || [],
      marketers: [],
      expandedMarketer: false,
      expandedField: true,
      content: data,
      slug: slug || "",
    }
  }
  componentWillMount() {
    // this.getMarketers()
    this.props.setSidebarVisibility(false)
  }

  getMarketers = () => {
    RestClient(GET_LIST, "marketers", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "first_name", order: "ASC" },
      filter: {},
    })
      .then((items) => {
        // console.log(items)
        this.setState({ marketers: items.data })
      })
      .catch((e) => {
        //console.error(e);
      })
  }
  checkContentSlug = (values, redirect) => {
    RestApiShortUrl(values.slug)
      .then((response) => {
        if (response.status >= 400) {
          throw new Error("Bad response from server")
        }
        return response.json()
      })
      .then((data) => {
        if (!data.exists) {
          this.props.save(values, redirect)
        } else {
          this.props.showNotification("The Slug already have", "warning")
        }
      })
      .catch((e) => {
        this.props.showNotification("Please try again", "warning")
        //console.error(e);
      })
  }
  getItemSlug = (slug) => {
    RestApiShortUrl(slug)
      .then((response) => {
        if (response.status >= 400) {
          throw new Error("Bad response from server")
        }
        return response.json()
      })
      .then((data) => {
        if (!data.exists) {
          this.props.showNotification("You can use this Slug", "info")
        } else {
          this.props.showNotification("The Slug already have", "warning")
        }
      })
      .catch((e) => {
        this.props.showNotification("Please try again", "warning")
        //console.error(e);
      })
  }
  handleExpandMarketerChange = (expanded) => {
    this.setState({ expandedMarketer: expanded })
  }
  handleExpandField = (expanded) => {
    this.setState({ expandedField: expanded })
  }

  onChangeUsers = (marketer, nameField) => {
    if (marketer && marketer.length === 0) {
      this.props.updateMarketerId(nameField, 0)
    } else {
      this.props.updateMarketerId(nameField, marketer[0].id)
    }
  }

  checkSlug = (index) => {
    const { marketers } = this.props
    if (marketers && marketers.length > 0) {
      const marketer = marketers[index]
      if (marketer && marketer.hasOwnProperty("slug") && marketer.slug !== "") {
        if (
          this.state.oldMarketers[index] !== undefined &&
          this.state.oldMarketers[index].slug !== undefined
        ) {
          if (marketers[index].slug !== this.state.oldMarketers[index].slug) {
            this.getItemSlug(marketers[index].slug)
          }
        } else {
          this.getItemSlug(marketers[index].slug)
        }
      } else {
        this.props.showNotification("Slug is empty", "warning")
      }
    }
  }

  renderMarketersList = ({ fields, meta: { error, submitFailed } }) => {
    return (
      <div>
        <Table selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={{ textAlign: "center" }}>
              <TableHeaderColumn>Marketer</TableHeaderColumn>
              <TableHeaderColumn>Slug</TableHeaderColumn>
              <TableHeaderColumn />
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {fields.map(this.renderMarketersFields)}
          </TableBody>
          <TableFooter adjustForCheckbox={false}>
            <TableRow>
              <TableRowColumn style={{ textAlign: "center" }}>
                <FlatButton
                  primary
                  label="add Marketer"
                  onClick={() => fields.push({ marketer_id: 0, slug: "" })}
                  icon={<ContentAdd />}
                />
              </TableRowColumn>
            </TableRow>
          </TableFooter>
        </Table>
        {submitFailed && error && <DivErrorMessage> {error} </DivErrorMessage>}
      </div>
    )
  }
  renderMarketersFields = (items, index, fields) => {
    // console.log(items)
    // console.log(fields)
    return (
      <TableRow key={index}>
        <TableRowColumn style={styles.rowMarketers}>
          <SearchMarketerContentShip
            data={[]}
            nameUsers={[]}
            marketerId={fields.get(index).marketer_id}
            onChangeUser={(item) =>
              this.onChangeUsers(item, `${items}.marketer_id`)
            }
            singleInput
          />
        </TableRowColumn>
        <TableRowColumn>
          <Field
            label=""
            name={`${items}.slug`}
            component={TextField}
            fullWidth
          />
        </TableRowColumn>
        <TableRowColumn style={styles.rowFooter}>
          <FlatButton
            primary
            label="Check Slug"
            onClick={() => this.checkSlug(index)}
          />
          <span style={{ padding: "5px" }} />
          <FlatButton
            primary
            label=""
            style={styles.removeButton}
            onClick={() => fields.remove(index)}
            icon={<ActionDelete />}
          />
        </TableRowColumn>
      </TableRow>
    )
  }

  renderMarketers = (children, record, resource, basePath) => {
    return (
      <div style={{ marginTop: 16 }}>
        <Card
          expanded={this.state.expandedMarketer}
          onExpandChange={this.handleExpandMarketerChange}
          style={{ marginBottom: 16 }}
        >
          <CardHeader
            title="Marketers"
            avatar={<Avatar icon={<IconPeople />} />}
            actAsExpander={true}
            showExpandableButton={true}
          />
          <CardText expandable={true} style={{ padding: 0 }}>
            <div style={{ margin: 16 }}>
              <FieldArray
                name="marketers"
                component={this.renderMarketersList}
              />
            </div>
          </CardText>
        </Card>
      </div>
    )
  }
  onSelectedTemplate = (item) => {
    let index = this.state.layoutSelected.length
    let newItem = { layout: item.layout, content: item.data, sort: index }
    this.setState({
      layoutSelected: update(this.state.layoutSelected, { $push: [newItem] }),
    })
  }
  onUdateListContent = (data) => {
    this.setState({
      layoutSelected: data,
    })
  }
  onChangeData = (data, dataRaw) => {
    this.setState({ layoutSelected: dataRaw, content: data })
    // console.log(dataRaw);
    // this.setState({ layoutSelected: dataRaw });
  }
  renderContentTemplate() {
    return (
      <div>
        <Flex p={[2]} justify={["flex-end"]}>
          <RaisedButton
            label="Reset Page"
            primary={true}
            onClick={this.onResetPage.bind(this)}
          />
        </Flex>
        <EditorLayout
          ref={(ref) => (this.editorpage = ref)}
          onChangeData={this.onChangeData.bind(this)}
          data={this.state.content}
          statusForm={this.props.statusForm}
        />
      </div>
    )
  }
  onResetPage = () => {
    this.setState({
      data: undefined,
      layoutSelected: [],
    })
    this.editorpage.onResetPage()
    this.props.updateContent(null)
  }
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar,
    } = this.props
    return (
      <div>
        <form className="simple-form">
          <DivContainer>
            <Card
              expanded={this.state.expandedField}
              onExpandChange={this.handleExpandField}
              style={{ marginBottom: 16 }}
            >
              <CardHeader
                title="Field"
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText expandable={true} style={{ padding: 0 }}>
                <div style={{ margin: 16 }}>
                  {Children.map(
                    children,
                    (input) =>
                      input && (
                        <div
                          key={input.props.source}
                          className={`aor-input-${input.props.source}`}
                          style={input.props.style}
                        >
                          <FormField
                            input={input}
                            resource={resource}
                            record={record}
                            basePath={basePath}
                          />
                        </div>
                      )
                  )}
                </div>
              </CardText>
            </Card>

            {this.renderMarketers(children, record, resource, basePath)}
          </DivContainer>
          {this.renderContentTemplate()}
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter,
            })}
        </form>
        <ValuesForm isDebug={true} />
      </div>
    )
  }
}
const DivContainer = styled.div`
  padding: 3em 1em 2em 1em;
  @media only screen and (min-width: 768px) {
    padding: 0em 1em 1em 1em;
  }
`

const DivErrorMessage = styled.div`
  position: relative;
  bottom: 15px;
  font-size: 12px;
  line-height: 12px;
  color: rgb(244, 67, 54);
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  padding-top: 8px;
  margin-top: 16px;
  border-top: 1px solid;
`

TemplateForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func,
  ]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  showNotification: PropTypes.func,
  statusForm: PropTypes.string,
}

TemplateForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />,
}

const selector = formValueSelector("record-form")
const enhance = compose(
  connect(
    (state, props) => {
      const marketers = selector(state, "marketers")
      return {
        initialValues: getDefaultValues(state, props),
        marketers,
      }
    },
    {
      setSidebarVisibility,
      showNotification: showNotificationAction,
      updateContent: (content) => change("record-form", "content", content),
      updateMarketerId: (nameField, id) => change("record-form", nameField, id),
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true,
  })
)

const styles = {
  rowMarketers: {
    width: "256px",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 8,
    paddingBottom: 8,
  },
  rowFooter: { textAlign: "right", width: 150, padding: 0 },
  removeButton: { minWidth: 30 },
  selectOptions: { width: "120px" },
}

export default enhance(TemplateForm)



// WEBPACK FOOTER //
// ./src/contents/TemplateForm.js